/**
 * Keys purged from `localStorage` on the router's auth gate when a user is
 * no longer authenticated (see `router/index.ts`'s `beforeResolve`).
 *
 * This list used to be seven inline `localStorage.removeItem` calls with
 * zero test coverage (R7). Pulling it out gives the purge behavior a spec
 * home and makes adding a new user-scoped key (e.g. `sss-filters`) a single
 * line instead of a silent gap.
 */
export const USER_SCOPED_PURGE_KEYS = [
    "fav_art",
    "fav_sec",
    "fav_web",
    "model-portfolios",
    "my-portfolios",
    "permissions",
    "user",
    "sss-filters",
] as const

export function purgeUserScopedStorage(): void {
    for (const key of USER_SCOPED_PURGE_KEYS) {
        localStorage.removeItem(key)
    }
}
